/** Section 1 */
import Section1FramePng from './assets/section1/Frame.png'
import Section1FrameWebp from './assets/section1/Frame.webp'
import Section1Frame2Png from './assets/section1/Frame2.png'
import Section1Frame2Webp from './assets/section1/Frame2.webp'

import Section1MobileFramePng from './assets/section1/FrameMobile.png'
import Section1MobileFrameWebp from './assets/section1/FrameMobile.webp'
import Section1MobileFrame2Png from './assets/section1/Frame2Mobile.png'
import Section1MobileFrame2Webp from './assets/section1/Frame2Mobile.webp'

/* Section 2 */
import Section2FramePng from './assets/section2/Frame.png'
import Section2MobileFramePng from './assets/section2/FrameMobile.png'
import Section2FrameWebp from './assets/section2/Frame.webp'
import Section2MobileFrameWebp from './assets/section2/FrameMobile.webp'

/* Section 3 */
import Section3FramePng from './assets/section3/Frame.png'
import Section3MobileFramePng from './assets/section3/FrameMobile.png'
import Section3FrameWebp from './assets/section3/Frame.webp'
import Section3MobileFrameWebp from './assets/section3/FrameMobile.webp'

/* Section 4 */
import Section4FramePng from './assets/section4/Frame.png'
import Section4FrameWebp from './assets/section4/Frame.webp'
import Section4Frame2Png from './assets/section4/Frame2.png'
import Section4Frame2Webp from './assets/section4/Frame2.webp'

import Section4MobileFramePng from './assets/section4/FrameMobile.png'
import Section4MobileFrameWebp from './assets/section4/FrameMobile.webp'
import Section4MobileFrame2Png from './assets/section4/Frame2Mobile.png'
import Section4MobileFrame2Webp from './assets/section4/Frame2Mobile.webp'

export interface Image {
  src: string
  src2x: string
  webp: string
  webp2x: string
  mobile?: {
    src: string
    src2x: string
    webp: string
    webp2x: string
  }
  width: number
  height: number
  alt?: string
}
export interface Item {
  key: number
  heading: string
  description: string[]
  images: Image[]
}

export const items: Item[] = [
  {
    key: 0,
    heading: `AI is officially everywhere`,
    description: [
      `Despite the uncertain economic landscape, there’s still an appetite to try new things, especially if those new things (ahem, AI) have proven results. Some examples of what businesses are spending money on? Efficiency. Personalization. Scalability.`,
      `When it comes to tech that delivers results across a variety of use cases, AI seems to fit the bill. And businesses are budgeting for it.`,
    ],
    images: [
      {
        src: Section1FramePng,
        src2x: Section1FramePng,
        webp: Section1FrameWebp,
        webp2x: Section1FrameWebp,
        height: 463,
        width: 844,
        mobile: {
          src: Section1MobileFramePng,
          src2x: Section1MobileFramePng,
          webp: Section1MobileFrameWebp,
          webp2x: Section1MobileFrameWebp,
        },
        alt: `Nearly half of businesses (48%) expect to spend more on AI-driven campaigns in the next 12 months. 56% of businesses will increase spending on marketing technology in the next year`,
      },
      {
        src: Section1Frame2Png,
        src2x: Section1Frame2Png,
        webp: Section1Frame2Webp,
        webp2x: Section1Frame2Webp,
        height: 463,
        width: 844,
        mobile: {
          src: Section1MobileFrame2Png,
          src2x: Section1MobileFrame2Png,
          webp: Section1MobileFrame2Webp,
          webp2x: Section1MobileFrame2Webp,
        },
        alt: `Only 6% say they expect to decrease their spending on marketing technology, a substantial drop from 2022 when 38% of professionals said the same`,
      },
    ],
  },
  {
    key: 1,
    heading: `AI is changing the marketing game, specifically with chatbots and personalized product recommendations`,
    description: [
      `You get a chatbot! You get a chatbot! Oprah memes aside, businesses are betting big on how to use AI in channels that are already providing the most ROI for their customers.`,
      `For both website and social, this means personalization driven by thousands of unique customer journeys that AI can build in mere seconds – enhancing copy, segmentations, and A/B testing faster than ever before.`,
    ],
    images: [
      {
        src: Section2FramePng,
        src2x: Section2FramePng,
        webp: Section2FrameWebp,
        webp2x: Section2FrameWebp,
        height: 463,
        width: 844,
        mobile: {
          src: Section2MobileFramePng,
          src2x: Section2MobileFramePng,
          webp: Section2MobileFrameWebp,
          webp2x: Section2MobileFrameWebp,
        },
        alt: `More than three-quarters of respondents (76%) are experimenting with AI on their marketing channels with websites and social media being the biggest places for disruption. 82% of businesses will be using some form of AI automation in their marketing efforts this year`,
      },
    ],
  },
  {
    key: 2,
    heading: `Do more with less: AI means more time and more money`,
    description: [
      `The trend of businesses amplifying their investment in AI signifies more than just a passing inclination.`,
      `While 46% of businesses think AI is delivering time savings for their business, they're also betting on it delivering real ROI as well. 37% also believe integrating AI into their marketing campaigns could be the catalyst for tangible financial savings.`,
    ],
    images: [
      {
        src: Section3FramePng,
        src2x: Section3FramePng,
        webp: Section3FrameWebp,
        webp2x: Section3FrameWebp,
        height: 463,
        width: 844,
        mobile: {
          src: Section3MobileFramePng,
          src2x: Section3MobileFramePng,
          webp: Section3MobileFrameWebp,
          webp2x: Section3MobileFrameWebp,
        },
        alt: `60% of businesses are adopting a ‘do more with less’ mentality when it comes to tools and technology. 58% believe that customers will welcome the use of AI in their marketing efforts if it delivers better service and experiences`,
      },
    ],
  },
  {
    key: 3,
    heading: `The key to unlocking AI? Quality data`,
    description: [
      `The transformative impact of AI on the business landscape is undeniable. However, the true potential of AI in driving growth hinges on the quality of the data it processes.`,
      `Given how many businesses are prioritizing first-party data in the coming year, it goes without saying that businesses will continue to need to do so as they also integrate AI efforts.`,
    ],
    images: [
      {
        src: Section4FramePng,
        src2x: Section4FramePng,
        webp: Section4FrameWebp,
        webp2x: Section4FrameWebp,
        height: 463,
        width: 844,
        mobile: {
          src: Section4MobileFramePng,
          src2x: Section4MobileFramePng,
          webp: Section4MobileFrameWebp,
          webp2x: Section4MobileFrameWebp,
        },
        alt: `65% of businesses say quality, accurate data is one of the most important ingredients for growth. 65% of respondents feel like AI could be more useful with access to higher-quality data.`,
      },
      {
        src: Section4Frame2Png,
        src2x: Section4Frame2Png,
        webp: Section4Frame2Webp,
        webp2x: Section4Frame2Webp,
        height: 463,
        width: 844,
        mobile: {
          src: Section4MobileFrame2Png,
          src2x: Section4MobileFrame2Png,
          webp: Section4MobileFrame2Webp,
          webp2x: Section4MobileFrame2Webp,
        },
        alt: `81% of businesses are prioritizing capturing and leveraging first-party data better in the coming year; more than the 71% who said the same in 2022`,
      },
    ],
  },
]
